export const containsInvalidValue = (arr, errors, touched) => {
  const invalidValues = arr.filter(
    i => touched.hasOwnProperty(i) && errors.hasOwnProperty(i)
  )
  return invalidValues.length !== 0
}
